import React from 'react';

/**
 * Composant carte - contenant visuel d'une section de formulaire
 * @param {string} titre - Titre de la section
 * @param {string} icone - Emoji ou icône affichée dans l'en-tête
 */
function Carte({ titre, icone, children }) {
  return (
    <div className="carte">
      {titre && (
        <div className="carte__entete">
          {icone && <div className="carte__icone">{icone}</div>}
          <h2 className="carte__titre">{titre}</h2>
        </div>
      )}
      <div className="carte__corps">{children}</div>
    </div>
  );
}

export default Carte;
